<template>
  <div class="home-main">
    <div class="header">
      <img style="height:125px; width: 1170px" class="filter-img" />
      <img
        style="height:125px; width: 1170px"
        class="img-fluid home-img"
        src="img/banner.png"
        alt="home-img"
      />
    </div>
    <div class="home-content">
      <p style="font-size: 25px; margin-bottom:0;">Suspensão do contrato de trabalho</p>
      <div style="width:100%; margin:0;" class="bordert"></div>
    </div>
    <div style="flex-direction:column" class="inputs flex-centered">
      <div class="input">
        Salário Atual
        <money @keydown.native="$event.key === '-' ? $event.preventDefault() : null" v-model="salario" v-bind="money" />
        <i
          class="fas fa-question-circle question-icon"
          v-b-popover.hover.top="textoHover"
        ></i>
      </div>
      <div class="buttons">
        <button @click="limpar()" class="limpar-btn">limpar</button>
        <button @click="click()" class="calcular-btn">calcular</button>
        <b-spinner v-show="spinner" style="margin-left:15px;"></b-spinner>
        <i v-show="erro" class="fas fa-times" style="font-size: 20px;margin-left:15px; color: red;"></i>
      </div>
    </div>
    <div v-show="resultado.$id == 1" style="flex-direction:column" class="resultado flex-centered">
      <p
        style="align-self: flex-start;font-size: 25px; color:#383838; font-weight: 700; font-style:italic; margin:30px 0 0 90px;"
      >Resultado de Cálculo</p>
      <div style="width:85%; margin:10px 0 30px 0;" class="bordert"></div>
      <div class="input">
        O valor do Benefício Emergencial pago
        <strong>pela União</strong>
        <input style="border:none" v-model="resultado.valorBeneficio" />
      </div>
      <div class="input">
        Valor Total
        <input style="border:none" v-model="resultado.valorTotal" />
      </div>
    </div>
    <div class="flex-centered" style="flex-direction:column;">
      <div class="obs">
        <ul v-if="resultado.$id != 1">
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">O empregador doméstico poderá através de acordo individual com o empregado suspender o contrato de
          trabalho por até 60 dias;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">O empregado doméstico receberá da União o valor correspondente a 100% do
          valor do seguro desemprego que ele teria direito, no caso um salário mínimo;</li>
          <li style="text-align: justify; color: #383838; font-size: 15px; margin: 25px;">Durante o período de
          suspensão do contrato de trabalho, empregado fará jus a todos os benefícios pagos pelo empregador
          (tais como auxilio-alimentação, plano de saúde, ...)</li>
        </ul>
        <ul v-else>
          <p v-html="textoCal"></p>
        </ul>
      </div>
      <button @click="$router.push('home')" class="voltar-btn">voltar</button>
    </div>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 50;
    },
    click() {
      if (
        this.salario == 0 
      ) {
        this.erro = true;
      } else {
        this.calcular();
      }
    },
    async calcular() {
      this.erro = false;
      this.spinner = true;
      this.resultado = await api.getSuspensaoD(this.salario, true);
      this.spinner = false;
    },
    limpar() {
      this.salario = 0;
      this.resultado = [];
      this.spinner = false;
      this.erro = false;
    }
  },
  computed: {},
  watch: {},
  data() {
    return {     
      salario: 0,
      scrolled: false,
      usuario: "",
      faturamento: false,
      resultado: [],
      spinner: false,
      erro: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: false
      },
      percentage: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: " %",
        precision: 2,
        masked: false
      },
      textoHover:'',
      textoCal:''
    };
  },
  async created() {
    window.scrollTo(0, 0);    
    this.textoHover = await api.getTextoExplicativaMP()
    this.textoCal = await api.gettextoNotaSuspensaoContrato()
  },
  async beforeCreate() {}
};
</script>

<style>
* {
  font-family: "Segoe UI";
}
</style>